export const UTM_SCHEMA_VERSION = 2 as const;

export enum UtmMedium {
    Cpc = 'cpc',
    PaidSocial = 'paid-social',
    Organic = 'organic',
    OrganicSocial = 'organic-social',
    Referral = 'referral',
    Email = 'email',
    Whatsapp = 'whatsapp',
    AiReferral = 'ai-referral',
    Affiliate = 'affiliate',
    Transactional = 'transactional',
}

export const UTM_MEDIUM_VALUES = new Set<string>(Object.values(UtmMedium));

/** Known inbound aliases remapped before the closed-list check. Typos like transacation are NOT remapped. */
export const UTM_MEDIUM_ALIASES: Record<string, UtmMedium> = {
    social: UtmMedium.OrganicSocial,
    seo: UtmMedium.Organic,
    career_website: UtmMedium.Referral,
    sharing: UtmMedium.OrganicSocial,
    share_job_modal: UtmMedium.OrganicSocial,
    organic_social: UtmMedium.OrganicSocial,
    'paid social': UtmMedium.PaidSocial,
    paidsocial: UtmMedium.PaidSocial,
    cpm: UtmMedium.Cpc,
    ppc: UtmMedium.Cpc,
};

export enum UtmClidSource {
    Google = 'google',
    Meta = 'meta',
    Tiktok = 'tiktok',
    Snapchat = 'snapchat',
    Bing = 'bing',
    Linkedin = 'linkedin',
}

export enum UtmAttributionRule {
    LastTouch30d = 'last_touch_30d',
    Unattributed = 'unattributed',
}

export enum UtmConfidence {
    Certain = 'certain',
    Inferred = 'inferred',
}

export enum UtmClassifyAction {
    Write = 'write',
    Ignore = 'ignore',
    Reject = 'reject',
}

export const COOKIE_FIRST_UTM = 'utm_first_visit';
export const COOKIE_LAST_UTM = 'utm_last_visit';
export const UTM_COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;
export const UTM_COOKIE_MAX_AGE_DAYS = 365;
